import React from "react";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Vision from "@/components/Vision";
import Pillars from "@/components/Pillars";
import Programs from "@/components/Programs";
import Calendar from "@/components/Calendar";
import Team from "@/components/Team";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Navbar />
        <Hero />
        <Vision />
        <Pillars />
        <Programs />
        <Calendar />
        <Team />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
